import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MaterialTable, { MTableToolbar } from 'material-table'
import ReferralsToolbar from './Referrals-Toolbar/referrals-toolbar'
import { ButtonListEdit } from 'theme'
import Edit from '@material-ui/icons/Edit'
import { ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED } from 'actions/action-constants'
import SnackbarError from 'components/snackbar/snackbar-error'
import CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS  from 'components/UserContext-FOR-CLASS-COMPONENTS/UserContext-FOR-CLASS-COMPONENTS'
class Referrals extends Component {
  static contextType = CONTEXT_USER_FOR_CLASS_COMPONENTS_FOR_COMPONENTS
  constructor (props) {
    super(props)
    this.state = {
      setRowsPerPage: 20,
      data: [],
      columns: [
        { title: 'Sys ID', field: 'id' },
        { title: 'CP / REG ID', field: 'regid' },
        { title: 'Name', field: 'lcommafname' },
        { title: 'Program', field: 'programdescription' },
        { title: 'Ref Rcvd Dte', field: 'referralreceiveddate' },
        { title: 'Aprvd Adms Dte', field: 'referralapprovedadmissiondate' },
        { title: 'Proj Rls Dte', field: 'referralprojectedreleasedate' },
        { title: 'Status', field: 'referraloutcomesdescription' }
      ]
    }
  }
  componentDidMount () {
    const c_USER = this.context
    this.props.getReferrals(c_USER.id)
    this.props.getProgramsAssignedToLoginList(c_USER.id)
  }
  render () {
    // console.log('4444-217 - Referrals - this.props ', this.props);
    return (
      // <div className={classes.root}>
      <div>
        {this.props.programsAssigned.length <= 1 ? (
          <div>
            <h4>{ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}</h4>
            <SnackbarError
              variant='error'
              message={ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}
            />
          </div>
        ) : (
          <div style={{ maxWidth: '100%' }}>
            <ReferralsToolbar />
            <MaterialTable
              title='Referrals'
              columns={this.state.columns}
              data={this.props.referrals}
              // onRowSelected='10'
              // rowData='10'
              // rowsperpage='10'
              // rows='10'
              rowsPerPage='10'
              options={{
                // search
                search: true,
                // header grouping
                grouping: true,
                // or
                // column filtering
                // filtering: true,
                // CSV export
                // pagination settings
                // show paging buttons
                // paging:false,
                // default items per page
                pageSize: 10,
                // paging options
                pageSizeOptions: [10, 25, 50, 100],
                // ???
                // columnsButton:false,
                // move buttons to right side of list
                // actionsColumnIndex: -1,
                // styling otions
                rowStyle: { height: '20px' },
                maxBodyHeight: 700,
                // export data buttons
                // exportButton: true,
                // default filename
                exportFileName: 'CPCMexport-Referrals'
                // comma delimited
                // exportDelimiter: ',',
              }}
              actions={[
                {
                  icon: 'edit',
                  tooltip: 'Edit Referral',
                  onClick: (event, rowData) => {
                    // this.props.history.push('/referrals/edit/' + rowData.id);
                    this.props.history.push('/referrals/' + rowData.id)
                  }
                }
              ]}
              components={{
                Toolbar: props => (
                  // <div style={{ backgroundColor: '#e8eaf5' }}>
                  // <div style={{ backgroundColor: '#ff7961' }}>
                  // <div style={{ backgroundColor: '#f44336' }}>
                  // <div style={{ backgroundColor: '#ff7961' }}>
                  // <div style={{ backgroundColor: '#ef9a9a' }}>
                  // WORKS
                  // <div style={{ backgroundColor: '#ffab8f' }}>
                  <div
                    style={{
                      background:
                        'linear-gradient(45deg, #ffab8f 10%, #fff 70%)', // blue / fade light blue
                      color: 'white'
                    }}>
                    <MTableToolbar {...props} />
                  </div>
                ),
                Action: props => (
                  <ButtonListEdit
                    onClick={event => props.action.onClick(event, props.data)}>
                    <Edit />
                  </ButtonListEdit>
                )
              }}
            />
          </div>
        )}
      </div>
    )
  }
}
Referrals.propTypes = {
  history: PropTypes.object
}
export default withRouter(Referrals)

















// //////////////////
// class RefreshData extends React.Component {
//   constructor(props) {
//     super(props);

//     this.tableRef = React.createRef();
//   }

//   render() {
//     return (
//       <MaterialTable
//         title="Refresh Data Preview"
//         tableRef={this.tableRef}
//         columns={[
//           {
//             title: 'Avatar',
//             field: 'avatar',
//             render: rowData => (
//               <img
//                 style={{ height: 36, borderRadius: '50%' }}
//                 src={rowData.avatar}
//               />
//             ),
//           },
//           { title: 'Id', field: 'id' },
//           { title: 'First Name', field: 'first_name' },
//           { title: 'Last Name', field: 'last_name' },
//         ]}
//         data={query =>
//           new Promise((resolve, reject) => {
//             let url = 'https://reqres.in/api/users?'
//             url += 'per_page=' + query.pageSize
//             url += '&page=' + (query.page + 1)
//             fetch(url)
//               .then(response => response.json())
//               .then(result => {
//                 resolve({
//                   data: result.data,
//                   page: result.page - 1,
//                   totalCount: result.total,
//                 })
//               })
//           })
//         }
//         actions={[
//           {
//             icon: 'refresh',
//             tooltip: 'Refresh Data',
//             isFreeAction: true,
//             onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
//           }
//         ]}
//       />
//     )
//   }
// }
// //////////////////////////////////

/////////////////////////////////////////
// did work

// // actions={[
// //   {
// //     tooltip: 'Remove All Selected Users',
// //     icon: 'delete',
// //     onClick: (evt, data) => alert('You want to delete ' + data.length + ' rows')
// //   }
// // ]}

// actions={[
//   {
//     icon: 'add',
//     tooltip: 'Add Referral',
//     isFreeAction: true,
//     // onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
//     onClick: () => this.props.history.push('/referrals/add'),
//   },
//   // {
//   //   icon: 'edit',
//   //   tooltip: 'Edit Referral',
//   //   isFreeAction: true,
//   //   // onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
//   //   onClick: () => this.props.history.push('/referrals/44404'),
//   //   onClick: () => this.props.history.push('/referrals/44404'),
//   // }
// ]}
//////////////////////////////////

/////////////////////
// dont use
//   // edit button to left
//   actions={[
//     {
//       icon: 'edit',
//       tooltip: 'Edit Entry',
//       onClick: (event, rowData) => {
//         console.log('4444-901 - Referrals - MaterialTable - event = ', event);
//         console.log('4444-902 - Referrals - MaterialTable - rowData = ', rowData);

//         alert('You Edited ' + rowData.id + ' ' + rowData.description)

//       },

//       // save icon
//       // icon: 'save',
//       // tooltip: 'Save User',
//       // onClick: (event, rowData) => {
//       //   console.log('4444-901 - Referrals - MaterialTable - event = ', event);
//       //   console.log('4444-902 - Referrals - MaterialTable - rowData = ', rowData);
//       //   // Do save operation
//       // }
//     },
// ]}
////////////////////////////////

// // custom Toolbar
// components={{
//   Toolbar: props => (
//       // <div style={{ backgroundColor: '#e8eaf5' }}>
//       // <div style={{ backgroundColor: '#ff7961' }}>
//       // <div style={{ backgroundColor: '#f44336' }}>
//       <div style={{ backgroundColor: '#ff7961' }}>
//           <MTableToolbar {...props} />
//       </div>
//   ),

//   // actions={[
//   //   {
//   //     icon: 'add',
//   //     tooltip: 'Add Referral',
//   //     isFreeAction: true,
//   //     // onClick: () => this.tableRef.current && this.tableRef.current.onQueryChange(),
//   //     onClick: () => this.props.history.push('/referrals/add'),
//   //   }
//   // ]},

//   Action: props => (
//     <Button
//       onClick={(event) => props.action.onClick(event, props.data)}
//       color="primary"
//       variant="contained"
//       style={{textTransform: 'none'}}
//       size="small"
//     >
//       My Button
//     </Button>
//   ),

// }}

// // add , update , and delete
// editable={{
//   // onRowAdd: newData =>
//   //   new Promise((resolve, reject) => {
//   //     var params = {
//   //       'description': newData.description
//   //       , 'tablename': this.props.referrals.tablename
//   //     }
//   //     this.props.addBOPINSTITUTION(params);
//   //       // add to state
//   //       const data = this.state.data;
//   //       data.push(newData);
//   //       this.setState({ data }, () => resolve());
//   //   }),

//   // onRowAdd: newData =>
//   //   new Promise((resolve, reject) => {
//   //     this.props.history.push('/referrals/add');
//   //     resolve();
//   //   }),

//   onRowUpdate: (newData, oldData) =>
//     new Promise((resolve, reject) => {
//       console.log('4444-9988-referrals-id', oldData);
//       var params = {
//         'description': newData.description
//         , 'tablename': this.props.referrals.tablename
//       }
//       this.props.updateBOPInstitution(newData.id,params);
//         // update the state
//         const data = this.state.data;
//         const index = data.indexOf(oldData);
//         data[index] = newData;
//         this.setState({ data }, () => resolve());
//     }),
//   // onRowDelete: oldData =>
//   //   new Promise((resolve, reject) => {
//   //     var params = {
//   //       'tablename': this.props.referrals.tablename
//   //     }
//   //     this.props.deleteBOPInstitution(oldData.id,params);
//   //       // remove from state
//   //       let data = this.state.data;
//   //       const index = data.indexOf(oldData);
//   //       data.splice(index, 1);
//   //       this.setState({ data }, () => resolve());
//   //   }),
// }}

/////////////////////////////
// // import CreateIcon from '@material-ui/icons/Create';
// actions={[
//   {
//     icon: 'save',
//     tooltip: 'Save User',
//     onClick: (event, rowData) => alert("You saved " + rowData.name)
//   }
// ]}
// components={{
//   Action: props => (
//     <Button
//       onClick={(event) => props.action.onClick(event, props.data)}
//       color="primary"
//       variant="contained"
//       style={{textTransform: 'none'}}
//       size="small"
//     >
//       My Button
//     </Button>
//   ),
// }}
////////////////

///////////////////////////

// editable={{

// onRowAdd: newData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data.push(newData);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowUpdate: (newData, oldData) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data[data.indexOf(oldData)] = newData;
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowDelete: oldData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data.splice(data.indexOf(oldData), 1);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),

// onRowAdd: newData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data.push(newData);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowUpdate: (newData, oldData) =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data[data.indexOf(oldData)] = newData;
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
// onRowDelete: oldData =>
//   new Promise(resolve => {
//     setTimeout(() => {
//       resolve();
//       // const data = [...this.state.data];
//       const data = [...this.props.referrals];
//       data.splice(data.indexOf(oldData), 1);
//       this.setState({ ...this.state, data });
//     }, 600);
//   }),
///////////////////////////////////
